import { render, staticRenderFns } from "./ConstraintSettings.vue?vue&type=template&id=135562f0&scoped=true&"
import script from "./ConstraintSettings.vue?vue&type=script&lang=js&"
export * from "./ConstraintSettings.vue?vue&type=script&lang=js&"
import style0 from "./ConstraintSettings.vue?vue&type=style&index=0&id=135562f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135562f0",
  null
  
)

export default component.exports